/* eslint-disable import/prefer-default-export */
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_APP_LOADED = 'UPDATE_APP_LOADED';